"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../helpers/api.js");
var _createAction = require("../../helpers/createAction.js");
var _constants = require("../../constants");
var updateActionConstants = {
  loadingConstant: _constants.EXAM_TEMPLATE_UPDATING,
  loadedConstant: _constants.EXAM_TEMPLATE_UPDATED,
  errorConstant: _constants.EXAM_TEMPLATE_UPDATE_ERROR
};
var questionsOnTemplatesConstants = {
  loadingConstant: _constants.QUESTIONS_ON_TEMPLATE_FETCHING,
  loadedConstant: _constants.QUESTIONS_ON_TEMPLATE_FETCHED,
  errorConstant: _constants.QUESTIONS_ON_TEMPLATE_FETCH_ERROR
};
var ExamTemplates = /*#__PURE__*/_createClass(function ExamTemplates(api) {
  var _this = this;
  _classCallCheck(this, ExamTemplates);
  this.examTemplatesFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/exam-templates");
    },
    request: function request(getState, organizationId) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/exam_templates"));
    },
    loadingConstant: _constants.EXAM_TEMPLATES_FETCHING,
    loadedConstant: _constants.EXAM_TEMPLATES_FETCHED,
    errorConstant: _constants.EXAM_TEMPLATES_FETCH_ERROR
  });
  this.examTemplatesListFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/exam-templates/fetch_list");
    },
    request: function request(getState, organizationId) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/exam_templates/fetch_list"));
    },
    loadingConstant: _constants.EXAM_TEMPLATES_LIST_FETCHING,
    loadedConstant: _constants.EXAM_TEMPLATES_LIST_FETCHED,
    errorConstant: _constants.EXAM_TEMPLATES_LIST_FETCH_ERROR
  });
  this.examTemplateFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(templateId) {
      return "organizations/exam-templates/".concat(templateId);
    },
    request: function request(getState, templateId) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/exam_templates/").concat(templateId));
    },
    loadingConstant: _constants.EXAM_TEMPLATE_FETCHING,
    loadedConstant: _constants.EXAM_TEMPLATE_FETCHED,
    errorConstant: _constants.EXAM_TEMPLATE_FETCH_ERROR
  });
  this.examTemplateCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/exam-templates/create");
    },
    request: function request(getState, organizationId, params) {
      return _this.api.post("".concat((0, _api.currentUserUrl)(getState()), "/organizations/").concat(organizationId, "/exam_templates"), {
        exam_template: params
      });
    },
    loadingConstant: _constants.EXAM_TEMPLATE_CREATING,
    loadedConstant: _constants.EXAM_TEMPLATE_CREATED,
    errorConstant: _constants.EXAM_TEMPLATE_CREATE_ERROR
  });
  this.examTemplateUpdate = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(templateId) {
      return "organizations/exam-templates/".concat(templateId, "/update");
    },
    request: function request(getState, templateId, params) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/exam_templates/").concat(templateId), {
        exam_template: params
      });
    }
  }, updateActionConstants));
  this.examTemplateArchive = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(templateId) {
      return "organizations/exam-templates/".concat(templateId, "/archive");
    },
    request: function request(getState, templateId) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/exam_templates/").concat(templateId, "/archive"));
    }
  }, updateActionConstants));
  this.examTemplateUnarchive = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(templateId) {
      return "organizations/exam-templates/".concat(templateId, "/unarchive");
    },
    request: function request(getState, templateId) {
      return _this.api.patch("".concat((0, _api.selectedOrganizationUrl)(getState()), "/exam_templates/").concat(templateId, "/unarchive"));
    }
  }, updateActionConstants));
  this.questionsOnTemplates = (0, _createAction.createApiRequestAction)(_objectSpread({
    getKey: function getKey(questionBankId) {
      return "question_banks/".concat(questionBankId, "/questions_used_on_templates");
    },
    request: function request(getState, questionBankId) {
      return _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/question_banks/").concat(questionBankId, "/questions_used_on_templates"));
    }
  }, questionsOnTemplatesConstants));
  this.api = api;
});
;
var _default = exports.default = ExamTemplates;